import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import * as actions from '../../actions/venue_show'
import Map from '../map/googlemap'

export class VenueShow extends Component {
  componentDidMount() {
    this.props.getVenue(this.props.params.id)
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <div>
          <div className="float-xs-right">
            <Link
              className="btn btn-success"
              to={'/venues/' + this.props.venue._id + '/edit'}
            >
              <strong>EDIT</strong>
            </Link>
          </div>
          <h1>{this.props.venue.name}</h1>
          <p>
            {this.props.venue.address}<br />
            {this.props.venue.city}<br />
            {this.props.venue.postcode}<br />
            {this.props.venue.country}
          </p>
          <Map location={this.props.venue.location} />
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  console.log('state: ' + JSON.stringify(state))
  return {
    venue: state.venue.item,
    loading: state.venue.loading,
  }
}

export default connect(mapStateToProps, actions)(VenueShow)



/** WEBPACK FOOTER **
 ** ./src/components/venues/show.js
 **/